import { ALinkStandaloneSize } from '../../atoms/ALinkStandalone/index';
import { ABodySize, ABodyColor } from '../../atoms/ABody/index';
import { DEFAULT_SEE_MORE_TEXT, DEFAULT_SEE_LESS_TEXT } from '../../utils/i18nConstants';

/** @deprecated Import `MParagraphDEFAULT_I18N` from `'@marriott/mi-web-ui-kit'` directly. */
export const MParagraphDEFAULT_I18N = {
  seeMore: DEFAULT_SEE_MORE_TEXT,
  seeLess: DEFAULT_SEE_LESS_TEXT,
} as const;

export enum MParagraphAlignment {
  Center = 'Center',
  Centered = 'Centered',
  Left = 'Left',
}

export interface MParagraphABodyProps {
  bodyText?: string;
  size?: ABodySize;
  color?: ABodyColor;
}

export interface MParagraphALinkStandaloneProps {
  size?: ALinkStandaloneSize;
  externalLink?: boolean;
  text?: string;
}

export interface MParagraphI18nProviderProps {
  seeMore?: string;
  seeLess?: string;
}

export interface MParagraphClickTrackingValues {
  seeMore?: string;
  seeLess?: string;
}

export interface MParagraphProps {
  alignment?: MParagraphAlignment;
  truncated?: boolean;
  truncateLines?: number;
  expanded?: boolean;
  bodySize?: ABodySize;
  bodyColor?: ABodyColor;
  truncationLinkSize?: ALinkStandaloneSize;
  children?: string;
  aBody?: MParagraphABodyProps;
  aLinkStandalone?: MParagraphALinkStandaloneProps;
  className?: string;
  i18nProperties?: MParagraphI18nProviderProps;
  custom_click_track_value?: MParagraphClickTrackingValues;
}
